import { createStyles, makeStyles } from "@mui/styles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    input: {
      "& .MuiInputBase-root": {
        backgroundColor: theme.white50,
      },
    },
    boolWrapper: {
      display: "flex",
      alignItems: "center",
    },
    textOperator: {
      fontSize: "16px",
      lineHeight: "24px",
      color: theme.gray500,
    },
    deleteWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "auto",
      borderRadius: "50%",
      backgroundColor: "F0F0F0",
      width: "24px",
      minWidth: "24px",
      height: "24px",
      cursor: "pointer",
      "& svg": {
        color: theme.gray500,
      },
    },
  }),
);
